import { useEffect, useState } from 'react'
import styles from './Curtain.module.css'

export interface CurtainCard {
  /** Distinguishes consecutive identical cards so each one plays. */
  key: number
  text: string
  holdMs: number
}

/**
 * The Curtain's act-card variant. Text is always authored — the engine never
 * generates it — so it is shown exactly as given.
 */
export default function Curtain({
  card,
  onDone,
}: {
  card: CurtainCard | null
  onDone: () => void
}) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!card) return
    // Next frame, so the transition has an initial state to move from.
    const raf = requestAnimationFrame(() => setVisible(true))

    const hold = Math.max(2500, card.holdMs || 5000)
    const fade = window.setTimeout(() => setVisible(false), hold)
    // Clear only after the fade has run, or the text would pop out.
    const clear = window.setTimeout(() => onDone(), hold + 1200)

    return () => {
      cancelAnimationFrame(raf)
      window.clearTimeout(fade)
      window.clearTimeout(clear)
      setVisible(false)
    }
  }, [card, onDone])

  if (!card) return null

  return (
    <div
      className={`${styles.curtain} ${visible ? styles.visible : ''}`}
      aria-live="polite"
    >
      <div className={styles.text}>{card.text}</div>
    </div>
  )
}
